import moment from 'moment';
import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { connect } from 'react-redux';
import { Navigate, useNavigate } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { cancelConferenceBooking, deleteConferenceBooking, getConferences, getMyConferenceBooking } from '../../actions/conference';

const Booking = ({auth: {isAuthenticated}, getMyConferenceBooking, conference: {bookings, conferences}, getConferences, cancelConferenceBooking, deleteConferenceBooking}) => {

  const navigate = useNavigate();

  useEffect(() => {
    getMyConferenceBooking();
  }, [getMyConferenceBooking])

  useEffect(() => {
    getConferences();
  }, [getConferences])

  if(!isAuthenticated) {
    return <Navigate to = '/homeScreen'/>
  }

  return (
    <div className="container">
      <h4><i className='fa-light fa-receipt' style={{color: 'var(--primary-color)'}} />&nbsp;Your Conference Bookings</h4>
      {bookings.map((b) => (

        <div className='bs container' style={{ maxWidth: '90%'}} key={b._id}>
          
          <Row>
            <Col style={{padding: '10px'}}>
              {conferences.map(conference => conference._id === b.conferenceid && 
              <>
                <Row><img src={conference.imageurl[0]} alt = 'conference img' /></Row>
                <Row><Col>Conference: {conference.name}</Col><Col style={{textAlign: 'right'}}>Type: Conference</Col></Row>
              </>
              )}
            </Col>
            <Col style={{padding: '10px'}}>
              <h6>Booking Details</h6>
              <Row><Col>Guest Name</Col><Col>{b.name}</Col></Row>
              <Row><Col>Mobile</Col><Col>{b.mobile}</Col></Row>
              <Row><Col>Duration</Col><Col>1 Day</Col></Row>
              <Row><Col>Booking For</Col><Col>{moment(b.dateon, 'DD-MM-YYYY').format('DD MMM YYYY')}</Col></Row>
              <Row><Col>Coupon</Col><Col>{b.couponcode && <>{b.couponcode}</>} {!b.couponcode && <>Not Applied</>}</Col></Row>
              <Row><Col>Amount</Col><Col><b><i className='fa fa-indian-rupee'></i>&nbsp;{b.totalamount}</b></Col></Row>
            </Col>
            <Col style={{padding: '10px'}}>
              <h6>Booking Status</h6>
              <Row><Col>Status</Col>
                <Col>
                  {b.status === 'saved' && <h6 style={{color: 'var(--danger-color)', border:'dashed 1px var(--danger-color)'}}><center>Not Confirmed</center></h6>}
                  {b.status === 'cancelled' && <h6 style={{color: 'var(--primary-color)', border:'dashed 1px var(--primary-color)'}}><center>Cancelled</center></h6>}
                  {b.status === 'confirmed' && <h6 style={{color: 'var(--success-color)', border: 'dashed 1px var(--success-color)'}}><center>Confirmed</center></h6>}
                </Col>
              </Row>
              { b.status === 'saved' &&
              <>
              <Row>
                <Col style={{color: 'var(--primary-color)'}}><u style={{cursor:'pointer'}} onClick={() => cancelConferenceBooking(b._id, navigate)}>Cancel</u></Col>
                <Col style={{color: 'var(--danger-color)'}}><u style={{cursor:'pointer'}} onClick={() => deleteConferenceBooking(b._id, navigate)}>Delete</u></Col>
              </Row>
              <Row style={{marginTop: '10px'}}>
                  <Col>Pay to Confirm</Col>
                  <Col>
                    <LinkContainer to={`/conferencepay/${b._id}/${b.totalamount}`}>
                      <button className='btn btn-outline-success'>Pay</button>
                    </LinkContainer>
                    </Col>
              </Row>
              </>
              }
              { b.status === 'confirmed' &&
              <>
                <Row><Col>Transaction Id</Col><Col>{b.transactionid ==='default' ? <>Not yet paid</> : <>{b.transactionid}</> }</Col></Row>
              </>
              }
            </Col>
          </Row>
        </div>

      ))}
  </div>
  )
};

Booking.propTypes = {
  auth: propTypes.object.isRequired,
  conference: propTypes.object.isRequired,
  getMyConferenceBooking: propTypes.func.isRequired,
  getConferences: propTypes.func.isRequired,
  cancelConferenceBooking: propTypes.func.isRequired,
  deleteConferenceBooking: propTypes.func.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  conference: state.conference,
});

export default connect(mapStateToProps, {getMyConferenceBooking, getConferences, cancelConferenceBooking, deleteConferenceBooking})(Booking);